import React, { FC } from 'react'
import { Progress } from 'rsuite'

import { PRIMARY_BRAND_COLOR } from '../../../utils/constants'
import { ReviewRatingQuantity } from '../../../utils/types/Review'
import { StarIconFullyColored } from '../../Icons/StarIconProgress'
import { fillMissingRatingQuantities, reviewRatingListItemKeys } from '../../../utils/reviewUtils'

import styles from '../../../styles/SingleProductReviewsSection.module.less'

interface ReviewHistogramProps {
  ratingQuantities: ReviewRatingQuantity[]
}

const ReviewHistogram: FC<ReviewHistogramProps> = (props) => {
  const { ratingQuantities } = props

  const ratingQuantitiesSorted = fillMissingRatingQuantities(ratingQuantities)

  const maximumQuantity = Math.max(...ratingQuantities.map((quantity) => quantity['review.rating.value']))
  const percentages = ratingQuantitiesSorted
    .map((quantity) => (maximumQuantity
      ? (quantity['review.rating.value'] / maximumQuantity) * 100
      : 0))

  const quantities = ratingQuantitiesSorted
    .map((quantity) => quantity['review.rating.value'])

  return (
    <div className={styles['modal-chart']}>
      {
        [5, 4, 3, 2, 1].map((number) => (
          <div
            key={number}
            className={styles['modal-chart-left-number']}
          >
            {number}
            <StarIconFullyColored />
          </div>
        ))
      }
      {
        percentages.map((percentage, index) => (
          <div
            key={`bar-${reviewRatingListItemKeys[index]}`}
            className={styles['modal-chart-bar']}
          >
            <Progress.Line
              percent={percentage}
              showInfo={false}
              strokeColor={PRIMARY_BRAND_COLOR}
              strokeWidth={6}
              className={styles['rs-progress-line']}
            />
          </div>
        ))
      }
      {
        quantities.map((quantity, index) => (
          <div
            key={`num-${reviewRatingListItemKeys[index]}`}
            className={styles['modal-chart-right-number']}
          >
            <p>{quantity}</p>
          </div>
        ))
      }
    </div>
  )
}

export default ReviewHistogram
